import { FC, ReactNode } from "react";

import classes from "./BottomSticky.module.css";

interface Props {
  children: ReactNode;
}

const BottomSticky: FC<Props> = ({ children }) => {
  return <div className={classes.bottomSticky}>{children}</div>;
};

export default BottomSticky;
